import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { instance } from '@/service/index';
import { LoginParams } from '@/pages/login/Login';
import layer from '@/utils/layer';
import history from '@/utils/history';
import { clearLocalStorage } from '@/utils';

type TeacherSchool = {
  id: number;
  name: string;
  schoolgradeDcode: string;
};

interface UserPrincipal {
  id: number;
  name: string;
  userType: 'ADMIN' | 'EDU' | 'TEACHER';
  username: string;
  schools: TeacherSchool[];
  currentSchool: TeacherSchool;
  permissionCodes: string[];
  eduDataScope: Record<string, string[]>;
}

export interface User {
  flag: number;
  userPrincipal: UserPrincipal;
  teacherSchools?: TeacherSchool[];
  permissionCodes: string[];
  eduDataScope: Record<string, string[]>;
}

export const loginAsync = createAsyncThunk(
  'user/login',
  async (params: LoginParams) => {
    const p = await instance.get<CustomSuccessData<User>>('index/login/bypwd', { params });
    if (p.data.code === 'SUCCESS') {
      const token = p.headers['auth-jwt'];
      const refreshToken = p.headers['auth-jwt-refresh'];
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
      return {
        ...p.data.data.userPrincipal,
        schools: p.data.data.teacherSchools || [],
        permissionCodes: p.data.data.permissionCodes || [],
        eduDataScope: p.data.data.eduDataScope
      };
    } else {
      layer.error('账号或密码错误');
    }
  }
);


interface UserState extends UserPrincipal {
  loading: boolean;
}
const initialState = {} as UserState;

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logout: function (state) {
      // eslint-disable-next-line no-param-reassign, @typescript-eslint/no-unused-vars
      state = initialState;
      clearLocalStorage();
      history.replace('/login');
    },
    setUserInfo (state, { payload }) {
      Object.assign(state, payload);
      if (payload.userType === 'TEACHER') {
        if (payload.schools.length === 0 || !payload.schools[0]) {
          layer.error('暂无学校');
        }
        state.currentSchool = payload.schools[0];
        localStorage.setItem('schoolId', String(state.currentSchool.id));
      }
      localStorage.setItem('userInfo', JSON.stringify(state));
    },
    changeSchool (state, { payload }) {
      const s = state.schools.find(u => u.id === payload);
      localStorage.setItem('schoolId', payload);
      if (s) {
        state.currentSchool = s;
        localStorage.setItem('userInfo', JSON.stringify(state));
      }
    }
  },
  extraReducers: build => {
    build
      .addCase(loginAsync.pending, state => {
        state.loading = true;
      })
      .addCase(loginAsync.fulfilled, (state, { payload }) => {
        Object.assign(state, payload);
        state.loading = false;
      })
      .addCase(loginAsync.rejected, state => {
        state.loading = false;
      });
  }
});

export const { logout, setUserInfo, changeSchool } = userSlice.actions;


export default userSlice;
